import WebServiceRequest from '../Api/WebServiceRequest'

class WalletGetAllRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('Wallet/GetAll')
    }
    setParams(data){
      super.setRequestParam(data)
    }
}
class WalletGetByUserIdRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
    }
    setUserId(id){
        super.setTag('Wallet/GetByUserId?userId='+id)
    }
}
class WalletUpdateRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('Wallet/updateWallet')
    }
    setParams(data){
        super.setRequestParamDataObj(data)
    }
}

class WalletHistoryGetListRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('WalletHistory/GetList')
    }
    setParams(data){
        super.setRequestParamDataObj(data)
    }
}

export {
    WalletGetAllRequest,
    WalletGetByUserIdRequest,
    WalletUpdateRequest,
    WalletHistoryGetListRequest
};
